const _version = "3.0.0"
function version() {
    return _version
}
export default version
